// Copyright (c) 2021-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { isString } from "../../../../../../io/hyperify/core/types/String";
import { CARD_ITEM_CLASS_NAME } from "../../../../core/constants/className";
import { Product } from "../../../../../../io/hyperify/core/store/types/product/Product";
import { ProductPrice } from "../../../../../../io/hyperify/core/store/types/product/ProductPrice";
import { SendanorProductUtils } from "../../../../core/utils/SendanorProductUtils";
import { BuyButton } from "../buyButton/BuyButton";
import { ButtonStyle } from "../../../../../../io/hyperify/core/frontend/button/ButtonStyle";
import "./CardItem.scss";

export interface CardItemProps {
  readonly className        ?: string;
  readonly buttonLabel      ?: string;
  readonly buttonRoute      ?: string;
  readonly icon             ?: string;
  readonly title            ?: string;
  readonly description      ?: string | ReactNode;
  readonly product          ?: Product;
  readonly productPrice     ?: ProductPrice;
  readonly dark             ?: boolean;
  readonly buttonStyle      ?: ButtonStyle;
  readonly children         ?: ReactNode;
}

export function CardItem (props: CardItemProps) {
  const children = props?.children;
  const className = props?.className;
  const buttonLabel = props?.buttonLabel;
  const icon = props?.icon;
  const title = props?.title;
  const description : string | ReactNode | undefined = props?.description;
  const descriptionNode : ReactNode = isString(description) ? <>{description}</> : description;
  const buttonRoute = props?.buttonRoute;
  const productPrice = props?.productPrice;
  const buttonStyle = props?.buttonStyle ?? ButtonStyle.PRIMARY;
  const product = props?.product;
  const dark = props?.dark ?? false;
  const isSoldOut : boolean = SendanorProductUtils.isSoldOut(product, productPrice);
  return (
    <div className={`${
      CARD_ITEM_CLASS_NAME
      + (className ? ` ${className}` : "")
      + (dark?' '+CARD_ITEM_CLASS_NAME+'-dark': '')
      + (isSoldOut?' '+CARD_ITEM_CLASS_NAME+'-sold-out': '')
    }`}>

      {icon ? (
        <div className= {`${CARD_ITEM_CLASS_NAME}-icon`}>{icon}</div>
      ) : null}

      {title ? (
        <div className={`${CARD_ITEM_CLASS_NAME}-title`}>{title ?? ""}</div>
      ) : null}

      {descriptionNode ? (
        <div className={`${CARD_ITEM_CLASS_NAME}-description`}>{descriptionNode}</div>
      ) : null}

      {children}

      <div className={`${CARD_ITEM_CLASS_NAME}-buttons`}>
      {buttonRoute ? (
          <Link
              to={buttonRoute}
              className={`${CARD_ITEM_CLASS_NAME}-button button button-link`}
          >{
            buttonLabel
          }</Link>
      ) : null}

      {product && productPrice ? (
          <BuyButton
            className={`${CARD_ITEM_CLASS_NAME}-button button`}
            product={product}
            style={buttonStyle}
            price={productPrice}
            enabled={!isSoldOut}
          >{
            buttonLabel ?? 'buy'
          }</BuyButton>
      ) : null}
      </div>

    </div>
  );
}
